import axios from 'axios';
import firebase from 'firebase/compat/app';
import React, { Component } from 'react';
import { FormControl, FormGroup } from 'react-bootstrap';
import Dialog from 'react-bootstrap-dialog';
import { BrowserView, MobileView } from 'react-device-detect';
import { Helmet } from 'react-helmet';
import LoadingOverlay from 'react-loading-overlay';
import RingLoader from 'react-spinners/RingLoader';
import swal from 'sweetalert2';
import { default as config, CONSTANTS } from '../../../../constants/constants';
import { auth } from '../../../../firebase';
import { displayNotification, getCopyrightHtml } from '../../../../utils/utils';
import VisitorMessagePanel from '../../../visitorMessagePanel/components/visitorMessagePanel';
import Logo from '../../../../components/widgets/Logo';
import MobileFooter from '../../../../components/widgets/MobileFooter';
import InfloWelcome from '../InfloWelcome';
import LoginInfloPage from '../login/LoginInfloPage';

const INITIAL_STATE = {
  fullname: '',
  email: '',
  passwordOne: '',
  passwordTwo: '',
  showPass: false,
  component: 'registerWithEmailInflo',
  error: null,
  loading: false
};

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value
});

class RegisterWithEmailInfloForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  redirectToLoginInflo = () => {
    this.setState({ component: 'loginInflo' });
  };

  redirectToInfloWelcome = () => {
    this.setState({ component: 'infloWelcome' });
  };

  showNotification = () => {
    const title = '<div class="titleModal">Welcome to Inflo!</div>';
    const message =
      '<p class="contentModal">Please check your email inbox and click the link in the email to confirm your registration.</p>' +
      getCopyrightHtml();
    displayNotification(message, {
      title,
      showConfirmButton: false,
      showCloseButton: false,
      allowOutsideClick: false
    });
  };

  onSubmit = (event) => {
    const { fullname, email, passwordOne, passwordTwo } = this.state;

    if (passwordOne !== passwordTwo) {
      swal({
        imageUrl: CONSTANTS.swalLogo,
        title: '<div class="titleModal">Passwords must match</div>',
        html:
          '<p class="contentModal">Please update your passwords and try again.</p>',
        showConfirmButton: false,
        showCloseButton: true,
        background: '#121C24',
        allowOutsideClick: false
      });
    } else {
      let currentUser;
      let token;
      this.setState(byPropKey('loading', true));
      const code = this.props.code;
      if (code !== undefined) {
        var request = axios.get(`${config.serverURL}/invitations?code=${code}`);
        request
          .then((response) => {
            if (response.data) {
              this.setState(byPropKey('loading', false));
              swal({
                imageUrl: CONSTANTS.swalLogo,
                title:
                  '<div class="titleModal">This link is not longer available</div>',
                html:
                  '<p class="contentModal">This link has been used.</p><p class="contentModal">Please contact Inflo support or your administrator.</p>',
                showConfirmButton: false,
                showCloseButton: true,
                background: '#121C24',
                allowOutsideClick: false
              });
              return Promise.reject({
                message:
                  'This link has been used. Please contact the administrator.'
              });
            }
          })
          .then(() => {
            auth
              .doFetchSignInMethodsForEmail(email)
              .then((result) => {
                if (result.length > 0) {
                  this.setState(byPropKey('loading', false));
                  return Promise.reject({
                    message:
                      'This email already exists. Please choose another one.'
                  });
                } else {
                  return auth.doCreateUserWithEmailAndPassword(
                    email,
                    passwordOne
                  );
                }
              })
              .then(() => {
                currentUser = firebase.auth().currentUser;
                if (currentUser) {
                  this.setState(byPropKey('loading', false));
                  this.showNotification();
                  currentUser.sendEmailVerification();
                  return currentUser.getIdToken();
                } else {
                  this.setState(byPropKey('loading', false));
                  return Promise.reject({ message: 'User not found' });
                }
              })
              .then((_token) => {
                token = _token;
                firebase.auth().currentUser.updateProfile({
                  displayName: fullname
                });
                return firebase.auth().currentUser.getIdToken();
              }) /*.then((_token) => {
                        token = _token;
                        const data = {
                            code
                        };
                        const options = {
                            method: 'POST',
                            headers: {'X-Firebase-Auth': token},
                            url: `${config.serverURL}/auth/invitation`,
                            params:data
                        }
                        return axios(options);
                    })*/
              .then(() => {
                firebase.auth().signOut();
                this.redirectToLoginInflo();
              })
              .catch((error) => {
                this.setState(byPropKey('error', error));
                this.setState(byPropKey('loading', false));
                swal({
                  imageUrl: CONSTANTS.swalLogo,
                  title:
                    '<div class="titleModal">We\'re sorry, there was an error</div>',
                  html: `<p class="contentModal">${error.message}</p>`,
                  showConfirmButton: false,
                  showCloseButton: true,
                  background: '#121C24',
                  allowOutsideClick: false
                });
              });
          });
      } else {
        auth
          .doFetchSignInMethodsForEmail(email)
          .then((result) => {
            if (result.length > 0) {
              this.setState(byPropKey('loading', false));
              return Promise.reject({
                message: 'This email already exists. Please choose another one.'
              });
            } else {
              return auth.doCreateUserWithEmailAndPassword(email, passwordOne);
            }
          })
          .then(() => {
            currentUser = firebase.auth().currentUser;
            if (currentUser) {
              this.setState(byPropKey('loading', false));

              this.showNotification();

              currentUser.sendEmailVerification();
              return currentUser.getIdToken();
            } else {
              this.setState(byPropKey('loading', false));
              return Promise.reject({ message: 'User not found' });
            }
          })
          .then((_token) => {
            token = _token;
            firebase.auth().currentUser.updateProfile({
              displayName: fullname
            });
            return firebase.auth().currentUser.getIdToken();
          })
          .then((_token) => {
            token = _token;
            const options = {
              method: 'POST',
              headers: { 'X-Firebase-Auth': token },
              url: `${config.serverURL}/auth/user`
            };
            return axios(options);
          })
          .then(() => {
            firebase.auth().signOut();
            this.redirectToLoginInflo();
          })
          .catch((error) => {
            this.setState(byPropKey('error', error));
            this.setState(byPropKey('loading', false));
            swal({
              imageUrl: CONSTANTS.swalLogo,
              title:
                '<div class="titleModal">We\'re sorry, there was an error</div>',
              html: `<p class="contentModal">${error.message}</p>`,
              showConfirmButton: false,
              showCloseButton: true,
              background: '#121C24',
              allowOutsideClick: false
            });
          });
      }
    }
    event.preventDefault();
  };

  toggleShowHide = () => {
    this.setState({ showPass: !this.state.showPass });
  };

  renderRegistrationPanel = () => {
    const { fullname, email, passwordOne, passwordTwo, loading } = this.state;
    const isInvalid =
      fullname === '' ||
      passwordOne === '' ||
      passwordOne.length < 6 ||
      passwordTwo === '' ||
      passwordTwo !== passwordOne ||
      email === '' ||
      email.length < 7;

    return (
      <>
        {!this.props.consumedLink ? (
          <form
            className="loginForm signinForm24"
            onSubmit={this.onSubmit.bind(this)}
          >
            <div
              style={{
                fontSize: 20,
                fontWeight: 400,
                marginTop: 72,
                marginBottom: 32
              }}
            >
              Create Account
            </div>
            <FormGroup controlId="fullname">
              {/* <ControlLabel>Name</ControlLabel> */}
              <div className="formLabel24">Name:</div>
              <FormControl
                componentClass="input"
                className="signIn-input24 form-control"
                style={{ display: 'inline-block' }}
                type="text"
                onChange={(event) =>
                  this.setState(byPropKey('fullname', event.target.value))
                }
              />
            </FormGroup>
            <FormGroup controlId="email">
              {/* <ControlLabel>Email</ControlLabel> */}
              <div className="formLabel24">Email:</div>
              <FormControl
                componentClass="input"
                className="signIn-input24 form-control"
                style={{ display: 'inline-block' }}
                type="email"
                onChange={(event) =>
                  this.setState(byPropKey('email', event.target.value))
                }
              />
            </FormGroup>
            <FormGroup controlId="passwordOne">
              {/* <ControlLabel>Password</ControlLabel> */}
              <div className="formLabel24">Password:</div>
              <FormControl
                componentClass="input"
                className="signIn-input24 form-control"
                style={{ display: 'inline-block' }}
                type={this.state.showPass ? 'text' : 'password'}
                onChange={(event) =>
                  this.setState(byPropKey('passwordOne', event.target.value))
                }
              />
              <i
                className={`fa ${
                  this.state.showPass ? 'fa-eye' : 'fa-eye-slash'
                } showHideIcon`}
                onClick={this.toggleShowHide}
                aria-hidden="true"
                title="Show/Hide Password"
              ></i>
            </FormGroup>
            <FormGroup controlId="passwordTwo">
              {/* <ControlLabel>Repeat password</ControlLabel> */}
              <div className="formLabel24">Confirm Password:</div>
              <FormControl
                componentClass="input"
                className="signIn-input24 form-control"
                style={{ display: 'inline-block', marginBottom: 15 }}
                type={this.state.showPass ? 'text' : 'password'}
                onChange={(event) =>
                  this.setState(byPropKey('passwordTwo', event.target.value))
                }
              />
              <i
                className={`fa ${
                  this.state.showPass ? 'fa-eye' : 'fa-eye-slash'
                } showHideIcon`}
                onClick={this.toggleShowHide}
                aria-hidden="true"
                title="Show/Hide Password"
              ></i>
            </FormGroup>
            <div style={{ textAlign: 'center' }}>
              <button
                disabled={isInvalid}
                type="submit"
                className="login-btn button-oval button-signin24 button-brand24 inflo24-gradient "
              >
                Create Account
              </button>
            </div>{' '}
            <hr className={'divider24'} />
            <div style={{ fontSize: 14 }}>Have an account?</div>
            <div
              className="new-acct other-link"
              onClick={this.redirectToLoginInflo.bind(this)}
              style={{ textDecoration: 'underline', fontSize: 14 }}
            >
              Sign In
            </div>
          </form>
        ) : (
          <div
            className="col-md-12"
            style={{
              textAlign: 'center',
              color: '#E31690',
              fontSize: '20pt',
              fontWeight: '500',
              marginBottom: '15px'
            }}
          >
            Unfortunately, this link is not valid anymore.
          </div>
        )}
        {this.props.consumedLink && (
          <div className="row" style={{ textAlign: 'center' }}>
            <button
              onClick={this.redirectToLoginInflo.bind(this)}
              className="login-btn button-oval button-signin24 button-brand24 inflo24-gradient "
            >
              OK
            </button>
          </div>
        )}
      </>
    );
  };

  render() {
    const { fullname, email, passwordOne, passwordTwo, loading } = this.state;

    const isInvalid =
      fullname === '' ||
      passwordOne === '' ||
      passwordOne.length < 6 ||
      passwordTwo === '' ||
      passwordTwo !== passwordOne ||
      email === '' ||
      email.length < 7;

    if (
      this.state.component &&
      this.state.component !== 'loginInflo' &&
      this.state.component !== 'dashboard' &&
      this.state.component !== 'infloWelcome'
    ) {
      return (
        <React.Fragment>
          <MobileView viewClassName="mv">
            <Helmet>
              {/* <style>{'body { background-color: #121C24!important; }'}</style> */}
            </Helmet>
            <LoadingOverlay
              active={loading}
              spinner={<RingLoader color={'orange'} />}
            >
              <Logo />
              <Dialog
                ref={(el) => {
                  this.dialog = el;
                }}
              />
              {!this.props.consumedLink ? (
                <>{this.renderRegistrationPanel()}</>
              ) : (
                <div
                  className="col-md-12"
                  style={{
                    textAlign: 'center',
                    color: '#E31690',
                    fontSize: '20pt',
                    fontWeight: '500',
                    marginBottom: '15px'
                  }}
                >
                  Unfortunately, this link is not valid anymore.
                </div>
              )}
              {/* <div className="form-group">
                                        <div className='btn login-inflo-button' onClick={this.redirectToLoginInflo.bind(this)}>
                                            {!this.props.consumedLink ? 'Login' : 'OK'}
                                        </div> */}
              {/* </div> */}
              <div
                className="new-acct other-link"
                onClick={this.redirectToLoginInflo.bind(this)}
                style={{ textDecoration: 'underline', fontSize: 14 }}
              >
                Sign In
              </div>

              <MobileFooter />
            </LoadingOverlay>
          </MobileView>
          <BrowserView>
            <Helmet>
              {/* <style>{'body { background-color: white!important; }'}</style> */}
            </Helmet>
            <div>
              <div
                className="paddingBlockInflo login-inflo-page"
                style={{
                  background: `url(${CONSTANTS.heroImage})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'top center',
                  backgroundSize: 'cover'
                }}
              >
                <div className="browser-signin-panel">
                  <Logo />
                  <Dialog
                    ref={(el) => {
                      this.dialog = el;
                    }}
                  />
                  {this.renderRegistrationPanel()}
                  {CONSTANTS.showEXIQ && (
                    <div className="footerInflo footerExIQ">
                      Inflo users&nbsp;
                      <div className="linkFooterInflo">
                        <div
                          style={{ textDecoration: 'underline' }}
                          onClick={this.redirectToInfloWelcome}
                        >
                          continue here »
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <VisitorMessagePanel />
              </div>
              <MobileFooter />
            </div>
          </BrowserView>
        </React.Fragment>
      );
    } else if (
      this.state.component &&
      this.state.component === 'infloWelcome'
    ) {
      return <InfloWelcome />;
    } else {
      return <LoginInfloPage />;
    }
  }
}

export default RegisterWithEmailInfloForm;
